var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "el-section" }, [
        _c(
          "div",
          {
            staticClass:
              "emd-container _highlight_header _footer_end _footer_spaced_mobile",
          },
          [
            _c("div", { staticClass: "emd-container__header" }, [
              _c("h2", { staticClass: "emd-text _size_section" }, [
                _vm._v(_vm._s(_vm.$t("webhook.form.title"))),
              ]),
            ]),
            _vm.loadingWebhook || _vm.loadingEvents
              ? _c(
                  "div",
                  { staticClass: "eu-pa_6 eu-align_center" },
                  [_c("emd-loader", { attrs: { type: "_invert" } })],
                  1
                )
              : _c("fieldset", { attrs: { disabled: _vm.fieldsetDisabled } }, [
                  _c("legend"),
                  _c(
                    "form",
                    {
                      attrs: {
                        name: "webhookSettings",
                        autocomplete: "off",
                        novalidate: "true",
                      },
                      on: { submit: _vm.saveWebhookSettings },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "emd-container__content" },
                        [
                          _vm.showAlert
                            ? _c(
                                "emd-alert",
                                {
                                  attrs: {
                                    variant: _vm.formError
                                      ? "danger"
                                      : "success",
                                    title: _vm.formError
                                      ? _vm.$t("alert.error-title")
                                      : _vm.$t("alert.success-title"),
                                  },
                                  on: {
                                    cancel: function ($event) {
                                      _vm.showAlert = false
                                    },
                                  },
                                },
                                [
                                  _c("template", { slot: "content" }, [
                                    _vm.formError
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            _vm.errors,
                                            function (error, index) {
                                              return _c("p", { key: index }, [
                                                _vm._v(
                                                  " " + _vm._s(error) + " "
                                                ),
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      : _c("p", [_vm._v(_vm._s(_vm.message))]),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "emd-panel" }, [
                            _c("div", { staticClass: "emd-panel__section" }, [
                              _c("div", { staticClass: "emd-panel__block" }, [
                                _c("div", { staticClass: "el-chunk" }, [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "emd-text _color_default _type_caption",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("webhook.form.informations")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "emd-panel__block" }, [
                                _c("div", { staticClass: "el-chunk" }, [
                                  _c("div", { staticClass: "emd-form-group" }, [
                                    _c("label", { staticClass: "emd-label" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("webhook.form.status"))
                                      ),
                                    ]),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "emd-switcher__label",
                                        attrs: { for: "webhookStatus" },
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.webhookSettings.status,
                                              expression:
                                                "webhookSettings.status",
                                            },
                                          ],
                                          staticClass:
                                            "emd-switcher _color_primary",
                                          attrs: {
                                            type: "checkbox",
                                            id: "webhookStatus",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.webhookSettings.status
                                            )
                                              ? _vm._i(
                                                  _vm.webhookSettings.status,
                                                  null
                                                ) > -1
                                              : _vm.webhookSettings.status,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.webhookSettings.status,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.webhookSettings,
                                                      "status",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.webhookSettings,
                                                      "status",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.webhookSettings,
                                                  "status",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _c("div", {
                                          staticClass: "emd-switcher__area",
                                        }),
                                        _vm.webhookSettings.status
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "emd-switcher__text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "webhook.form.active"
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "el-chunk" }, [
                                  _c("div", { staticClass: "emd-form-group" }, [
                                    _c(
                                      "label",
                                      { staticClass: "emd-label _required" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("webhook.form.url"))
                                        ),
                                      ]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.webhookSettings.url,
                                          expression: "webhookSettings.url",
                                        },
                                      ],
                                      staticClass: "emd-input",
                                      class: {
                                        _state_error:
                                          _vm.webhookSettings.url &&
                                          _vm.$v.webhookSettings.url.$invalid,
                                      },
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.$t("webhook.form.url"),
                                        id: "url",
                                      },
                                      domProps: {
                                        value: _vm.webhookSettings.url,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.webhookSettings,
                                            "url",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm.webhookSettings.url &&
                                    _vm.$v.webhookSettings.url.$invalid
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "emd-input-feedback _state_error",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "webhook.form.url-error"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.webhookSettings.url &&
                                    !_vm.$v.webhookSettings.url.maxLength
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "emd-input-feedback _state_error",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "webhook.form.url-max-length",
                                                    {
                                                      maxLength:
                                                        _vm.webhookSettings
                                                          .maxLengthUrl,
                                                    }
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                                _c("div", { staticClass: "el-chunk" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "emd-form-group _condensed_30",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "emd-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "webhook.form.max-retries-label"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.webhookSettings.max_attempts,
                                            expression:
                                              "webhookSettings.max_attempts",
                                          },
                                        ],
                                        staticClass: "emd-input",
                                        class: {
                                          _state_error:
                                            _vm.$v.webhookSettings.max_attempts
                                              .$invalid,
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "maxAttempts",
                                          max: _vm.maxAttempts,
                                          placeholder: _vm.$t(
                                            "webhook.form.max-retries",
                                            {
                                              maxAttempts: _vm.maxAttempts,
                                            }
                                          ),
                                        },
                                        domProps: {
                                          value:
                                            _vm.webhookSettings.max_attempts,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.webhookSettings,
                                              "max_attempts",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm.webhookSettings.max_attempts &&
                                      _vm.$v.webhookSettings.max_attempts
                                        .$invalid
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "emd-input-feedback _state_error",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "webhook.form.max-retries-error"
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(_vm.maxAttempts) +
                                                  " "
                                              ),
                                              _vm.maxAttempts === 1
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "webhook.form.retries-singular"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm.maxAttempts > 1
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "webhook.form.retries-plural"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "el-chunk" }, [
                                  _c("div", { staticClass: "emd-form-group" }, [
                                    _c("label", { staticClass: "emd-label" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "webhook.form.enable-authentication"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "emd-switcher__label",
                                        attrs: { for: "authenticationEnabled" },
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.webhookSettings
                                                  .authentication_enabled,
                                              expression:
                                                "webhookSettings.authentication_enabled",
                                            },
                                          ],
                                          staticClass:
                                            "emd-switcher _color_primary",
                                          attrs: {
                                            type: "checkbox",
                                            id: "authenticationEnabled",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.webhookSettings
                                                .authentication_enabled
                                            )
                                              ? _vm._i(
                                                  _vm.webhookSettings
                                                    .authentication_enabled,
                                                  null
                                                ) > -1
                                              : _vm.webhookSettings
                                                  .authentication_enabled,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.webhookSettings
                                                    .authentication_enabled,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.webhookSettings,
                                                      "authentication_enabled",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.webhookSettings,
                                                      "authentication_enabled",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.webhookSettings,
                                                  "authentication_enabled",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _c("div", {
                                          staticClass: "emd-switcher__area",
                                        }),
                                        _vm.webhookSettings
                                          .authentication_enabled
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "emd-switcher__text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "webhook.form.active"
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm.webhookSettings.authentication_enabled
                                  ? _c("div", { staticClass: "el-chunk" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "eu-flex eu-column eu-row_sm",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "eu-flex-item eu-basis_6_md",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "emd-form-group",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "emd-label _required",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "webhook.form.username"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.webhookSettings
                                                            .basic_authentication
                                                            .username,
                                                        expression:
                                                          "\n                              webhookSettings.basic_authentication.username\n                            ",
                                                      },
                                                    ],
                                                    staticClass: "emd-input",
                                                    class: {
                                                      _state_error:
                                                        _vm.webhookSettings
                                                          .basic_authentication
                                                          .username &&
                                                        _vm.$v.webhookSettings
                                                          .basic_authentication
                                                          .username.$invalid,
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "username",
                                                      placeholder: _vm.$t(
                                                        "webhook.form.username"
                                                      ),
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.webhookSettings
                                                          .basic_authentication
                                                          .username,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.webhookSettings
                                                            .basic_authentication,
                                                          "username",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "eu-flex-item eu-basis_6_md",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "emd-form-group",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "emd-label _required",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "webhook.form.password"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  !_vm.showInputPassword &&
                                                  _vm.webhookSettings.id
                                                    ? _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "emd-btn _type_link",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openModal(
                                                                "getPasswordAuthentication"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "webhook.form.click-to-view"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.showInputPassword
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "emd-input-group",
                                                        },
                                                        [
                                                          _vm.inputType ===
                                                          "checkbox"
                                                            ? _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .webhookSettings
                                                                        .basic_authentication
                                                                        .password,
                                                                    expression:
                                                                      "\n                                webhookSettings.basic_authentication.password\n                              ",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "emd-input fs-hide",
                                                                class: {
                                                                  _state_error:
                                                                    _vm
                                                                      .webhookSettings
                                                                      .basic_authentication
                                                                      .password &&
                                                                    _vm.$v
                                                                      .webhookSettings
                                                                      .basic_authentication
                                                                      .password
                                                                      .$invalid,
                                                                },
                                                                attrs: {
                                                                  id: "password",
                                                                  type: "checkbox",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    Array.isArray(
                                                                      _vm
                                                                        .webhookSettings
                                                                        .basic_authentication
                                                                        .password
                                                                    )
                                                                      ? _vm._i(
                                                                          _vm
                                                                            .webhookSettings
                                                                            .basic_authentication
                                                                            .password,
                                                                          null
                                                                        ) > -1
                                                                      : _vm
                                                                          .webhookSettings
                                                                          .basic_authentication
                                                                          .password,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      var $$a =
                                                                          _vm
                                                                            .webhookSettings
                                                                            .basic_authentication
                                                                            .password,
                                                                        $$el =
                                                                          $event.target,
                                                                        $$c =
                                                                          $$el.checked
                                                                            ? true
                                                                            : false
                                                                      if (
                                                                        Array.isArray(
                                                                          $$a
                                                                        )
                                                                      ) {
                                                                        var $$v =
                                                                            null,
                                                                          $$i =
                                                                            _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                        if (
                                                                          $$el.checked
                                                                        ) {
                                                                          $$i <
                                                                            0 &&
                                                                            _vm.$set(
                                                                              _vm
                                                                                .webhookSettings
                                                                                .basic_authentication,
                                                                              "password",
                                                                              $$a.concat(
                                                                                [
                                                                                  $$v,
                                                                                ]
                                                                              )
                                                                            )
                                                                        } else {
                                                                          $$i >
                                                                            -1 &&
                                                                            _vm.$set(
                                                                              _vm
                                                                                .webhookSettings
                                                                                .basic_authentication,
                                                                              "password",
                                                                              $$a
                                                                                .slice(
                                                                                  0,
                                                                                  $$i
                                                                                )
                                                                                .concat(
                                                                                  $$a.slice(
                                                                                    $$i +
                                                                                      1
                                                                                  )
                                                                                )
                                                                            )
                                                                        }
                                                                      } else {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .webhookSettings
                                                                            .basic_authentication,
                                                                          "password",
                                                                          $$c
                                                                        )
                                                                      }
                                                                    },
                                                                },
                                                              })
                                                            : _vm.inputType ===
                                                              "radio"
                                                            ? _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .webhookSettings
                                                                        .basic_authentication
                                                                        .password,
                                                                    expression:
                                                                      "\n                                webhookSettings.basic_authentication.password\n                              ",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "emd-input fs-hide",
                                                                class: {
                                                                  _state_error:
                                                                    _vm
                                                                      .webhookSettings
                                                                      .basic_authentication
                                                                      .password &&
                                                                    _vm.$v
                                                                      .webhookSettings
                                                                      .basic_authentication
                                                                      .password
                                                                      .$invalid,
                                                                },
                                                                attrs: {
                                                                  id: "password",
                                                                  type: "radio",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    _vm._q(
                                                                      _vm
                                                                        .webhookSettings
                                                                        .basic_authentication
                                                                        .password,
                                                                      null
                                                                    ),
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$set(
                                                                        _vm
                                                                          .webhookSettings
                                                                          .basic_authentication,
                                                                        "password",
                                                                        null
                                                                      )
                                                                    },
                                                                },
                                                              })
                                                            : _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .webhookSettings
                                                                        .basic_authentication
                                                                        .password,
                                                                    expression:
                                                                      "\n                                webhookSettings.basic_authentication.password\n                              ",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "emd-input fs-hide",
                                                                class: {
                                                                  _state_error:
                                                                    _vm
                                                                      .webhookSettings
                                                                      .basic_authentication
                                                                      .password &&
                                                                    _vm.$v
                                                                      .webhookSettings
                                                                      .basic_authentication
                                                                      .password
                                                                      .$invalid,
                                                                },
                                                                attrs: {
                                                                  id: "password",
                                                                  type: _vm.inputType,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .webhookSettings
                                                                      .basic_authentication
                                                                      .password,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.$set(
                                                                        _vm
                                                                          .webhookSettings
                                                                          .basic_authentication,
                                                                        "password",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "emd-input-icon__link",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleInput()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm.inputType ===
                                                              "password"
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "uil uil-eye",
                                                                  })
                                                                : _vm._e(),
                                                              _vm.inputType ===
                                                              "text"
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "uil uil-eye-slash",
                                                                  })
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "emd-panel" }, [
                            _c("div", { staticClass: "emd-panel__section" }, [
                              _c("div", { staticClass: "emd-panel__block" }, [
                                _c("div", { staticClass: "el-chunk" }, [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "emd-text _color_default _type_caption",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("webhook.form.events")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "emd-panel__block" }, [
                                _c("div", { staticClass: "el-chunk" }, [
                                  _c(
                                    "div",
                                    { staticClass: "el-grid-list _size_large" },
                                    _vm._l(
                                      _vm.eventsCategorized,
                                      function (eventCategorized, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass:
                                              "emd-container _type_card",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "emd-checkbox-group",
                                                class: {
                                                  _open:
                                                    eventCategorized.categoryOpenned,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "emd-checkbox-group__header",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleCategory(
                                                          eventCategorized,
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "emd-btn-collapse",
                                                        class: {
                                                          _open:
                                                            eventCategorized.categoryOpenned,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              width: "12px",
                                                              height: "12px",
                                                              viewBox:
                                                                "0 0 14 14",
                                                              version: "1.1",
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              "xmlns:xlink":
                                                                "http://www.w3.org/1999/xlink",
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M0,7 L14,7",
                                                                id: "h",
                                                                stroke:
                                                                  "#323A43",
                                                                "stroke-width":
                                                                  "2",
                                                              },
                                                            }),
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M7,14 L7,0",
                                                                id: "v",
                                                                stroke:
                                                                  "#323A43",
                                                                "stroke-width":
                                                                  "2",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "emd-checkbox__text emd-text _size_small _type_label",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                eventCategorized.name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c("jade-checkbox", {
                                                      attrs: {
                                                        id: `events-${index}`,
                                                        value:
                                                          eventCategorized.allEventsChecked,
                                                        label: _vm.$t(
                                                          "webhook.form.select-all"
                                                        ),
                                                        indeterminate:
                                                          !eventCategorized.allEventsChecked &&
                                                          !eventCategorized.allEventsNotChecked &&
                                                          eventCategorized.allEventsNotChecked !==
                                                            undefined,
                                                      },
                                                      on: {
                                                        "update:value":
                                                          function ($event) {
                                                            return _vm.$set(
                                                              eventCategorized,
                                                              "allEventsChecked",
                                                              $event
                                                            )
                                                          },
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleCheckAllOfCategory(
                                                            eventCategorized,
                                                            index
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "emd-checkbox-group__content",
                                                  },
                                                  _vm._l(
                                                    eventCategorized.events,
                                                    function (event, id) {
                                                      return _c(
                                                        "jade-checkbox",
                                                        {
                                                          key: id,
                                                          attrs: {
                                                            id: event.name,
                                                            label: event.name,
                                                            supportText:
                                                              event.description,
                                                            value:
                                                              event.checked,
                                                          },
                                                          on: {
                                                            "update:value":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  event,
                                                                  "checked",
                                                                  $event
                                                                )
                                                              },
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toggleEvent(
                                                                event,
                                                                eventCategorized,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        }
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm.showActions()
                            ? _c("div", { staticClass: "emd-panel" }, [
                                _c(
                                  "div",
                                  { staticClass: "emd-panel__section" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "emd-panel__block" },
                                      [
                                        _c("div", { staticClass: "el-chunk" }, [
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "emd-text _color_default _type_caption",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "webhook.form.actions"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "emd-panel__block" },
                                      [
                                        _c(
                                          "ul",
                                          {
                                            staticClass:
                                              "emd-list _space_base _inline eu-flex",
                                          },
                                          [
                                            _vm.webhookSettings.status
                                              ? _c("li", [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "emd-btn _color_secondary",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openModal(
                                                            "disableSettings"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        class: _vm
                                                          .webhookSettings
                                                          .send_disabled
                                                          ? "uil uil-unlock-alt"
                                                          : "uil uil-lock-alt",
                                                        attrs: {
                                                          transform: "width-16",
                                                        },
                                                      }),
                                                      _vm.webhookSettings
                                                        .send_disabled
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "webhook.form.unblock"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "webhook.form.block"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _c("li", [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "emd-btn _color_danger",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openModal(
                                                        "deleteWebhook"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "uil uil-times-circle",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "webhook.form.delete"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _c("hr", {
                            staticClass: "emd-divider eu-my_4 fade-in",
                          }),
                          _c("password-confirmation", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: true,
                                expression: "true",
                              },
                            ],
                            staticClass: "fade-in",
                            attrs: { label: _vm.labelPassword },
                            model: {
                              value: _vm.webhookSettings.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.webhookSettings, "password", $$v)
                              },
                              expression: "webhookSettings.password",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "emd-container__footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "emd-btn _color_primary _type_text",
                            attrs: { type: "button" },
                            on: { click: _vm.cancelButton },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("webhook.form.cancel")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "emd-btn _color_primary",
                            attrs: {
                              tabindex: "0",
                              type: "submit",
                              disabled: _vm.$v.$invalid,
                            },
                          },
                          [
                            !_vm.buttonLoading
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t("webhook.form.save"))),
                                ])
                              : _vm._e(),
                            _vm.buttonLoading
                              ? _c("emd-loader", { attrs: { type: "" } })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]),
          ]
        ),
      ]),
      _c("log-links", {
        attrs: {
          entity: _vm.webhookSettings,
          title: _vm.$t("log-links.webhook-settings"),
        },
      }),
      _vm.modalOpenned
        ? _c("modal-password", {
            attrs: { callback: _vm.actionModal },
            on: { cancel: _vm.closeModal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }